/* eslint-disable react/no-danger, @next/next/no-img-element */
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { uniqBy } from 'lodash';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { sanitiseText } from '../../helpers/sanitiseText';
import { useToggle } from '../../hooks/useToggle';
import ThemeContext from '../../providers/ThemeProvider';

const redirectToDealPage = (url) => {
  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
};

const PopularGiftsListItem = ({ listItem, title, subTitle, toggleText }) => {
  const [isToggled, setToggled] = useToggle();
  const theme = useContext(ThemeContext);
  const buttonToggleMessage = `View more ${toggleText}`;

  const featuredGifts = uniqBy(
    listItem?.filter((entry) => entry.priority),
    'priority',
  );
  const sortedFeaturedGifts = featuredGifts.sort(
    (a, b) => a.priority - b.priority,
  );

  return (
    <>
      <div className="popular-locations-list">
        <h3>{title}</h3>
        <p>{subTitle}</p>
        <div className="popular-locations-list-priorities">
          {sortedFeaturedGifts?.map((featuredGiftsItem) => {
            const url = featuredGiftsItem.canonicalUrl;

            return (
              <div key={featuredGiftsItem.id}>
                <a
                  href={url}
                  onClick={() => redirectToDealPage(url)}
                  role="button"
                >
                  <img
                    alt={'location.nearMeLocationName'}
                    src={featuredGiftsItem.imageUrl}
                  />
                  <h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: sanitiseText(featuredGiftsItem.displayName),
                      }}
                    />
                  </h4>
                </a>
              </div>
            );
          })}
        </div>
        <button onClick={setToggled} type="button">
          <span className="toggle-text">{buttonToggleMessage}</span>
          <FontAwesomeIcon
            icon={isToggled ? faAngleUp : faAngleDown}
            size="lg"
          />
        </button>
        <ul className={classNames('toggle-list', { open: isToggled })}>
          {listItem?.map((item) => (
            <li key={item.id}>
              <Link href={item.canonicalUrl ?? ''}>
                <a href={item.canonicalUrl}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanitiseText(item.displayName),
                    }}
                  />
                </a>
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <style jsx>{`
        .popular-locations-list {
          font-family: 'Open Sans', sans-serif;
          border-radius: 10px;
          background-color: #ffffff;
          box-shadow: 0 2px 5px rgb(0 0 0 / 40%);
          padding: 10px;
          margin-top: 20px;
          width: 100%;
        }
        .popular-locations-list h3 {
          font-size: 19px;
        }
        .popular-locations-list h3,
        .popular-locations-list p {
          text-align: center;
        }
        .popular-locations-list button {
          color: ${theme.colors.primary};
          border: none;
          background-color: transparent;
          font-family: inherit;
          padding: 10px 0;
          cursor: pointer;
          width: 100%;
          font-weight: bold;
          font-size: 19px;
        }
        .popular-locations-list ul {
          padding: 0;
          list-style: none;
          -moz-column-count: 4;
          -moz-column-gap: 20px;
          -webkit-column-count: 4;
          -webkit-column-gap: 20px;
          column-count: 4;
          column-gap: 20px;
          border-top: 1px solid rgb(0 0 0 / 40%);
          padding-top: 10px;
        }
        .popular-locations-list ul li {
          margin-bottom: 8px;
          font-weight: bold;
        }
        .popular-locations-list ul li a {
          color: #212529;
        }
        .toggle-list {
          display: none;
        }
        .toggle-text {
          text-transform: capitalize;
        }
        .popular-locations-list-priorities {
          display: flex;
          flex-wrap: wrap;
        }
        .popular-locations-list-priorities div {
          box-sizing: border-box;
          text-align: center;
          cursor: pointer;
          flex: 25%;
          padding: 4px;
        }
        .popular-locations-list-priorities div img {
          width: 100%;
          height: 80%;
        }
        .popular-locations-list-priorities div h4 {
          color: black;
        }
        .toggle-list.open {
          display: block;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .popular-locations-list-priorities div {
            flex: 50%;
          }
        }
      `}</style>
    </>
  );
};

PopularGiftsListItem.propTypes = {
  listItem: PropTypes.array,
  subTitle: PropTypes.string,
  title: PropTypes.string,
  toggleText: PropTypes.string,
};

export default PopularGiftsListItem;
